/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CoinInputs */

const en_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coins`)
};

const ar_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عملات`)
};

const de_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Münzen`)
};

const es_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monedas`)
};

const fr_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pièces`)
};

const it_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monete`)
};

const ja_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コイン`)
};

const ko_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코인`)
};

const pt_br_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moedas`)
};

const ru_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Монеты`)
};

const th_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เหรียญ`)
};

const tr_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetonlar`)
};

const zh_cn_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金币`)
};

const zh_tw_coin = /** @type {(inputs: CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金幣`)
};

/**
* | output |
* | --- |
* | "Coins" |
*
* @param {CoinInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const coin = /** @type {((inputs?: CoinInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CoinInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coin(inputs)
	if (locale === "ar") return ar_coin(inputs)
	if (locale === "de") return de_coin(inputs)
	if (locale === "es") return es_coin(inputs)
	if (locale === "fr") return fr_coin(inputs)
	if (locale === "it") return it_coin(inputs)
	if (locale === "ja") return ja_coin(inputs)
	if (locale === "ko") return ko_coin(inputs)
	if (locale === "pt_br") return pt_br_coin(inputs)
	if (locale === "ru") return ru_coin(inputs)
	if (locale === "th") return th_coin(inputs)
	if (locale === "tr") return tr_coin(inputs)
	if (locale === "zh_cn") return zh_cn_coin(inputs)
	return zh_tw_coin(inputs)
});